import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useScrollText } from '../../hooks/useScrollText';

import styles from './Message.module.css';
import cn from 'classnames';

import { AnimatePresence, motion } from 'framer-motion';

const Message = ({
  className,
  message,
  setDelay,
  messagesWrapper,
  duration,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  const lines = useMemo(
    () => message.content?.split(/\r\n/),
    [message.content],
  );

  // useScrollText(
  //   contentRef,
  //   contentContainerRef,
  //   message?.content,
  //   setDelay,
  //   messagesWrapper,
  //   lines,
  // );

  const [curentLines, setCurrentLines] = useState(lines?.slice(0, 3));

  const notIsFirst = useRef(null);

  useEffect(() => {
    let id = '';
    if (lines?.length > 3) {
      const delayInterval = ((lines?.length - 3) * duration) / 3 + duration;
      setDelay(delayInterval);

      id = setTimeout(() => {
        notIsFirst.current = true;
        setCurrentLines(lines.slice(3, 6));
      }, duration * 0.7);
    }

    return () => {
      clearTimeout(id);
    };
  }, [lines, duration]);

  return (
    <div className={cn(styles.wrapper, className)}>
      {message?.content && (
        <>
          <div className={styles.content}>
            <div className={styles.textWrapper} ref={contentContainerRef}>
              <div className={styles.text} ref={contentRef}>
                <AnimatePresence mode="wait">
                  {curentLines.map((line, idx) => (
                    <motion.div
                      initial={{
                        maskPosition: '100% 0%',
                        WebkitMaskPosition: '100% 0%',
                      }}
                      animate={{
                        maskPosition: '100% 100%',
                        WebkitMaskPosition: '100% 100%',
                        transition: {
                          duration: 0.5,
                          delay: 0.5 * idx + (notIsFirst.current ? 0 : 1),
                        },
                      }}
                      exit={{
                        opacity: 0,
                        transition: { duration: 0.5, delay: 0.5 },
                      }}
                      className={styles.line}
                      key={line + idx + 'msg'}
                    >
                      <motion.div
                        initial={{ y: '100%' }}
                        animate={{ y: 0 }}
                        transition={{
                          duration: 0.5,
                          delay: 0.5 * idx + (notIsFirst.current ? 0 : 1),
                        }}
                      >
                        {line}
                      </motion.div>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(Message);
